function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Custom Preset 24 Copy");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Custom-Preset-24-Copy",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "hand-click",
  transform: "translate(12.000000, 8.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "btn_timeline_active",
  transform: "translate(19.000000, 0.000000)",
  fill: "#F0AB00",
  stroke: "#0ABBEF",
  strokeOpacity: 0.5,
  strokeWidth: 10
}, React.createElement("circle", {
  id: "Oval",
  cx: 20,
  cy: 20,
  r: 20
})), React.createElement("g", {
  id: "noun_Horizontal-Swipe_445544",
  transform: "translate(0.000000, 10.000000)",
  fill: "#FFFFFF"
}, React.createElement("path", {
  d: "M87.3047552,68.9414158 L87.3146436,68.9314704 C79.6758484,64.1029619 69.4759554,65.0179419 62.8260009,71.7062466 L59.3304487,75.2269305 L59.3304487,10.4454345 C59.3304487,4.97544555 54.880665,0.5 49.4420406,0.5 C44.0034161,0.5 39.5585767,4.97544555 39.5585767,10.4454345 L39.5585767,49.7914816 C37.7539422,47.5637043 35.0296857,46.1116708 31.9494466,46.1116708 C29.8086063,46.1116708 27.8358688,46.8177967 26.2191141,47.9863852 L4.92442725,60.3833694 L4.93925986,60.408233 C1.99745845,62.1287932 1.0380333e-08,65.2914414 1.0380333e-08,68.9513613 L1.0380333e-08,85.3066284 C1.0380333e-08,103.089065 14.3283034,117.5 32.0087771,117.5 C40.5721385,117.5 48.3295946,114.098661 54.0698156,108.588891 L54.0747598,108.633645 L87.9475017,74.5655591 C89.3516557,73.1533074 89.3516557,70.8608847 87.9425575,69.448633 C87.7447894,69.2497243 87.5321886,69.0756792 87.3047552,68.9414158 Z",
  id: "Path",
  transform: "translate(44.500000, 59.000000) scale(-1, 1) translate(-44.500000, -59.000000) "
}))));

var SvgHandClick = function SvgHandClick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "105px",
    height: "136px",
    viewBox: "0 0 105 136",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHandClick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hand-click.39e4ef02.svg";
export { ForwardRef as ReactComponent };